export default {
  marker: {
    textAlign: 'center',
    fontSize: '11px',
    lineHeight: '11px',
    paddingTop: '2px',
    paddingLeft: '2px',
    paddingRight: '2px',
    height: '12px',
    borderRadius: '8px',
    minWidth: '12px',
    color: '#000',
    boxShadow: '0px 1px 2px #888',
    border: 'solid 1px #fff',
  },
  circle: {
    width: '6px',
    height: '6px',
    borderRadius: '4px',
    border: 'solid 1px #444',
    opacity: 0.7,
    backgroundColor: '#fff',
  },
};
